import React, { useState, useEffect } from "react";
import { Button, CircularProgress } from "@mui/material";
import { Form, Formik } from "formik";
import Service from "../../../../Service/Invoice/cashInOut.service";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import FormControl from "Components/MUI_components/FormControl/fomikFormControl";
import Loading from "Components/MUI_components/loading";
import { openSnackbar } from "Redux/Actions/snackbarActions";
import customerService from "Service/Customer/customer.service";
import supplierService from "Service/Suppliers/supplier.service";
import { values } from "lodash";
import { logoutUser } from "Redux/Actions/authAction";

const AddCashInOut = ({ setOpen, code, setSubmitted, popupState }) => {
  const dispatch = useDispatch();
  const today = new Date().toISOString().split("T")[0];
  const Validation = yup.object({
    type: yup.object().required("Type is required").nullable(),
    amount: yup.number().required("Amount is required").nullable(),
    dateTime: yup
      .date()
      .required("Date is required")
      .max(new Date(), "Date cannot be in the future")
      .nullable(),
  });

  const stockInType = [
    { name: "CASH IN", code: 0 },
    { name: "CASH OUT", code: 1 },
  ];

  const [initValue, setInitValue] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const getUnit = async () => {
      if (code) {
        try {
          let response = await Service.get(code);
          // converting NULL value into Empty string
          response = JSON.parse(
            JSON.stringify(response).replace(/:null/gi, ':""')
          );
          setInitValue({
            ...response,
            isActive: response.isActive == 1 ? true : false,
          });
        } catch (e) {
          dispatch(openSnackbar(true, "error", e));
        }
      } else {
        setInitValue({
          customer: "",
          supplier: "",
          amount: "",
          type: "",
          dateTime: "",
        });
      }
      setIsLoaded(true);
    };
    getUnit();
  }, [code, dispatch]);

  const handleSubmit = async (values) => {
    try {
      if (code) {
        await Service.edit(values, code);
      } else {
        const res = await Service.create(values);

        if (res.recordExiting) {
          alert(res.message);
          return;
        }

        if (setSubmitted !== undefined) {
          setSubmitted((prev) => !prev);
        }

        /**
         * popupState prop is passing from logout functionality. When admin / user clicks logout, system will 
           ask to enter Cash-Out amount. If user enters amount and clicks on Save, system need to proceed Logout function.
           To achieve this, we are passing popupState prop from logout functionality and checking it here. If it is
           true, system will execute logout function. If it is false / undefined, system will consider, it is not logout functionality.
         */
        if (popupState !== undefined) {
          dispatch(logoutUser());
        }
      }

      setOpen(false);
      dispatch(
        openSnackbar(
          true,
          "success",
          `Cash In/Out ${code ? "updated" : "created"} successfully`
        )
      );
    } catch (e) {
      const errorMsg = e instanceof Error ? e?.message : String(e);
      dispatch(openSnackbar(true, "error", errorMsg));

      // For debuggin purpose
      // console.log(errorMsg);
    }
  };

  return (
    <>
      {isLoaded ? (
        <Formik
          initialValues={initValue}
          validationSchema={Validation}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form autoComplete="off">
              <div className="mt row">
                <div className="col-4">
                  <FormControl
                    control="autoComplete"
                    name="type"
                    label="Type"
                    getOptionLabel={(option) => option.name}
                    options={stockInType}
                  />
                </div>
                <div className="col-4">
                  <FormControl
                    control="input"
                    type="date"
                    name="dateTime"
                    label="Date"
                    inputProps={{
                      max: today,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </div>
                <div className="col-4">
                  <FormControl
                    control="currency"
                    label="Amount"
                    name="amount"
                  />
                </div>
              </div>
              <div className="mt row center">
                <div className="col-4">
                  <FormControl
                    control="asynchronousAutoComplete"
                    name="customer"
                    disabled={values.supplier}
                    label="Customer"
                    Service={customerService}
                    getOptionLabel={(option) =>
                      option.firstName + "-" + option.phone1 + "-" + option.code
                    }
                  />
                </div>
                <div className="col-4">
                  <FormControl
                    control="asynchronousAutoComplete"
                    name="supplier"
                    label="Supplier"
                    Service={supplierService}
                    getOptionLabel={(option) => option.name + " " + option.code}
                    disabled={values.customer}
                  />
                </div>
              </div>
              <div className="mb row flex-end">
                {/* {code && (
                <FormControl control="switch" name="isActive" label="Active" />
              )} */}
                <Button
                  type="submit"
                  style={{ marginRight: 5 }}
                  variant="contained"
                  color="primary"
                  disabled={isSubmitting}
                  startIcon={
                    isSubmitting && (
                      <CircularProgress color="inherit" size={20} />
                    )
                  }
                >
                  {code ? "Update" : "Save"}
                </Button>
                {/* <Button
                  onClick={() => {
                    setOpen(false);
                  }}
                  variant="contained"
                  color="secondary"
                >
                  Cancel
                </Button> */}
              </div>
            </Form>
          )}
        </Formik>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default AddCashInOut;
